module.exports = __webpack_public_path__ + "static/media/worksheet.62d2d443.svg";